import model from 'modules/buildingLevel2/buildingLevel2Model';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.customers,
  fields.createdAt,
  fields.updatedAt
];
